/**
 * External dependencies
 */
export default class Partner {
  constructor(cscom) {
    if (!(this instanceof Partner)) {
      return new Partner(cscom);
    }
    this.cscom = cscom;
  }

  activePartner() {
    return this.cscom.req.get("/api/rest/talink/partner");
  }

  update(body) {
    return this.cscom.req
      .put("/api/rest/talink/partner", body)
      .then((result) => {
        return result;
      });
  }
}
